import React, { Component } from 'react'
import $ from 'jquery'
import { injectIntl, FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { dataIntegrationAriaLabel } from '../Constants/AriaLabelText'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import { withErrorBoundary } from '@vmockinc/dashboard/Common/commonComps/ErrorBoundary'
import { notification } from '../../services/helpers'


class IntegrateToLinkedIn extends Component {
  constructor(props) {
    super(props)
    this.trackClickDebounce = _.debounce(this.trackClick, 3000, true)
    this.trackGoToDebounce = _.debounce(this.trackClick, 5000, true)
  }

  trackClick(tag) {
    sendTrackingData('event', 'aspire_integration_modal', 'click', tag)
  }

  copyToClipboard(element) {
    var text = $(element).get(0) // Grab the node of the element
    var selection = window.getSelection() // Get the Selection object
    var range = document.createRange() // Create a new range
    range.selectNodeContents(text) // Select the content of the node from line 1
    selection.removeAllRanges() // Delete any old ranges
    selection.addRange(range) // Add the range to selection
    document.execCommand('copy') // Execute the command
    notification(this.props.intl.formatMessage({ id: 'aspire.integrateToLinkedIn.copiedToClipboard', defaultMessage: 'Copied to clipboard!' }), 'info')
    this.trackClickDebounce(`${element}-copy_btn`)
  }

  render() {
    const {
      hideModal,
      downloadImage,
      sectionToSuggestCopy,
      linkedInUrl,
      imageData,
      community,
      benchmark,
      getTextFromFeedback,
      intl,
    } = this.props

    let sectionTiles = []
    let textArray = getTextFromFeedback()
    if (_.isEmpty(sectionToSuggestCopy) || _.isEmpty(textArray)) {
      sectionTiles.push(<EmptyComponent intl={intl} />)
    } else {
      _.map(textArray, (value, key) => {
        if (value['title'] == 'Profile Picture') {
          let imageUrl = value['content']
          if (imageData.refresh_url) {
            imageUrl = imageData.url
          }
          sectionTiles.push(
            <ProfilePictureTile
              imageUrl={imageUrl}
              scoreChange={value['scoreChange']}
              id={value['id']}
              downloadImage={downloadImage}
              intl={intl}
            />
          )
        } else {
          sectionTiles.push(
            <SectionTile
              sectionTitle={value['title']}
              sectionContent={value['content']}
              scoreChange={value['scoreChange']}
              copyFunction={this.copyToClipboard.bind(this)}
              id={value['id']}
              intl={intl}
            />
          )
        }
        if (
          value['title'].indexOf('Experience') +
            value['title'].indexOf('Education') !=
          -2
        ) {
          sectionTiles.push(
            <div
              className="copy-note"
              tabIndex={0}
              aria-label={dataIntegrationAriaLabel(intl)['copy_note']}>
              <FormattedMessage
                id="aspire.integrateToLinkedIn.copyNote"
                defaultMessage="Note - Only description will be copied"
              />
            </div>
          )
        }
      })
    }
    let mainHeadingText = intl.formatMessage({ id: 'aspire.integrateToLinkedIn.mainHeading', defaultMessage: 'Update changes on LinkedIn' })

    return (
      <div className="linkedin-integration-modal-container">
        <div className="ITL-modal-header">
          <button
            className="btn ITL-close-btn"
            onClick={hideModal}
            aria-label={dataIntegrationAriaLabel(intl)['close']}>
            <span className="icon-cross" />
          </button>
          <div className="main-heading">
            <span className="main-heading-text">
              {mainHeadingText}
            </span>
          </div>
          <div className="sub-heading">
            {_.isEmpty(sectionToSuggestCopy) ? null : (
              <span className="sub-heading-text">
                <FormattedMessage
                  id="aspire.integrateToLinkedIn.subHeading"
                  defaultMessage="Paste below sections on your {platform}"
                  values={{
                    platform: (
                      <a
                        className="link-to-linkedin"
                        href={linkedInUrl}
                        onClick={() => {
                          this.trackGoToDebounce('go_to_linkedin')
                        }}
                        target="_blank"
                        aria-label={dataIntegrationAriaLabel(intl)['go_to_linkedin']}
                      >
                        {intl.formatMessage({ id: 'aspire.integrateToLinkedIn.goToLinkedInAria', defaultMessage: 'LinkedIn' })}&nbsp;
                        <img
                          src={`${process.env.APP_BASE_URL}dist/images/open-in-new-tab.svg`}
                          alt={intl.formatMessage({ id: 'aspire.integrateToLinkedIn.openLinkedInIconAlt', defaultMessage: 'open linkedin icon' })}
                        />
                      </a>
                    )
                  }}
                />
              </span>
            )}
          </div>
        </div>
        <div className="clearfix" />
        <div className="ITL-modal-content">{sectionTiles}</div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    imageData: state.imageData,
  }
}

export default connect(
  mapStateToProps,
  {}
)(withErrorBoundary(injectIntl(IntegrateToLinkedIn), 'aspire', 'integrate_modal'))

function SectionTile({
  sectionTitle,
  sectionContent,
  scoreChange,
  copyFunction,
  id,
  intl,
}) {
  return (
    <div className="row">
      <SectionTitleImprovement
        scoreChange={scoreChange}
        sectionTitle={sectionTitle}
        intl={intl}
      />
      <div className="col col-sm-2">
        <button
          className="btn copy-btn"
          onClick={() => {
            copyFunction(`#${id}`)
          }}
          aria-label={dataIntegrationAriaLabel(intl)['copy']}>
          <span className="ITL-copy-icon">
            <img
              src={`${process.env.APP_BASE_URL}dist/images/copy-icon.svg`}
              alt={intl.formatMessage({ id: 'aspire.integrateToLinkedIn.copyIconAlt', defaultMessage: 'copy icon' })}
            />
          </span>{' '}
          <FormattedMessage id="aspire.integrateToLinkedIn.copyBtn" defaultMessage="Copy" />
        </button>
      </div>
      <div className="col-sm-12 ITL-section-content">
        <div className="ITL-section-content-text" id={id}>
          {sectionContent}
        </div>
      </div>
    </div>
  )
}

function ProfilePictureTile({ scoreChange, id, imageUrl, downloadImage, intl }) {
  return (
    <div className="row">
      <SectionTitleImprovement
        scoreChange={scoreChange}
        sectionTitle={'Profile Picture'}
        intl={intl}
      />
      <div className="col col-sm-2">
        <button
          className="btn download-btn"
          onClick={() => {
            downloadImage(imageUrl, intl)
          }}
          aria-label={dataIntegrationAriaLabel(intl)['download']}>
          <span className="ITL-download-icon">
            <img
              src={`${process.env.APP_BASE_URL}dist/images/download-icon.svg`}
              alt={intl.formatMessage({ id: 'aspire.integrateToLinkedIn.downloadIconAlt', defaultMessage: 'download icon' })}
            />
          </span>{' '}
          <FormattedMessage id="aspire.integrateToLinkedIn.downloadBtn" defaultMessage="Download" />
        </button>
      </div>
      <div className="col-sm-12 ITL-section-content picture">
        <div className="ITL-section-content-picture">
          <img src={imageUrl}
          /* DONETEMP: (CHANGE HERE) */
          alt={intl.formatMessage({ id: 'aspire.integrateToLinkedIn.profilePictureAlt', defaultMessage: 'profile picture' })} />
        </div>
        <div className="ITL-section-content-picture-text">
          <FormattedMessage id="aspire.integrateToLinkedIn.profilePictureText" defaultMessage="This picture is fit to be directly uploaded on your LinkedIn profile" />
        </div>
      </div>
    </div>
  )
}

function SectionTitleImprovement({ sectionTitle, scoreChange, intl }) {
  let sectionHeading = sectionTitle === 'Summary' ? 'About' : sectionTitle

  const sectionIdMap = {
    "Profile Picture": "aspire.logscreenNames.profilePicture",
    "Personal Information": "aspire.logscreenNames.personalInformation",
    "Headline": "aspire.logscreenNames.headline",
    "About": "aspire.logscreenNames.summary",
    "Experience": "aspire.logscreenNames.experience",
    "Education": "aspire.logscreenNames.education"
  };

  const id = sectionIdMap[sectionHeading] || sectionHeading;
  sectionHeading = intl.formatMessage({ id: id, defaultMessage: sectionHeading });

  return (
    <div
      className="col col-sm-10"
      role="region"
      tabIndex={0}
      //   scoreChange == 0 ? 'Score Unchanged' : 'Score Improved'
      // }`}
      aria-label={intl.formatMessage({
        id: 'aspire.integrateToLinkedIn.sectionTitleAria',
        defaultMessage: '{sectionTitle} {scoreChange, select, 0 {Score Unchanged} other {Score Improved}}'
      }, { sectionHeading, scoreChange })}
    >
      <span className="ITL-section-heading">
        {sectionHeading}
      </span>
      {scoreChange == 0 ? (
        <span className="score-status-text">
          <FormattedMessage id="aspire.integrateToLinkedIn.scoreUnchanged" defaultMessage="Score Unchanged" />
        </span>
      ) : (
        <span>
          <span className="up-arrow-icon">
            {' '}
            <img
              src={`${process.env.APP_BASE_URL}dist/images/up-arrow.svg`}
              alt={intl.formatMessage({ id: 'aspire.integrateToLinkedIn.improvementArrowAlt', defaultMessage: 'improvement arrow' })}
            />
          </span>
          <span className="score-status-text green">
            <FormattedMessage id="aspire.integrateToLinkedIn.scoreImproved" defaultMessage="Score Improved" />
          </span>
        </span>
      )}
    </div>
  )
}

function EmptyComponent({ intl }) {
  return (
    <div className="empty-image-icon-row">
      <img
        src={`${process.env.APP_BASE_URL}dist/images/no-edits-made.svg`}
        alt={intl.formatMessage({ id: 'aspire.integrateToLinkedIn.noEditMadeAlt', defaultMessage: 'no edit made' })}
      />
      <div className="empty-sub-text">
        <span tabIndex={0} /* DONETEMP: (CHANGE HERE) */ aria-label={dataIntegrationAriaLabel(intl)['no_changes']}>
          <FormattedMessage id="aspire.integrateToLinkedIn.noChanges" defaultMessage="You haven’t made any changes yet" />
        </span>
      </div>
      <div className="empty-main-text">
        <span
          tabIndex={0}
          aria-label={dataIntegrationAriaLabel(intl)['start_editing']}>
          <FormattedMessage id="aspire.integrateToLinkedIn.startEditing" defaultMessage="Start editing to see improvements" />
        </span>
      </div>
    </div>
  )
}
